export default __webpack_public_path__ + "static/media/refresh.7bf547c6.svg";